import dashboards from '@/apis/dashboards';
import * as facebook from '@/apis/facebook';
import library from '@/apis/library';
import product from '@/apis/library/product';
import shorturl from '@/apis/shorturl';

export const DashboardAPI = dashboards;
export const FacebookAPI = facebook;
export const LibraryAPI = library;
export const LibraryProductAPI = product;
export const ShortUrlAPI = shorturl;
